import { server } from '../config';

export const GetGenioLiteOptions = async (params) => {
  const { parentId, city, department } = params;
  const result = await fetch(
    `${server.apiURL}genio/getOptions?parentId=${parentId}&city=${city}&department=${department}`,
    {
      credentials: 'include',
    },
  );
  return result.json();
};

export const GetGenioFaqs = async (params) => {
  const url = `${server.apiURL}genio/getFaqs?key=${params.key}`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(params),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const GrievanceSubmit = async ({
  vertical,
  category,
  ticketCreator,
  nm,
  createdBy,
  mob,
  issueType,
  issueSubType,
  issueComment,
  document,
  city,
  oid,
  orderId,
  docid,
  src,
  srcType,
  srcNm,
  srcMob,
  projectId,
  parentId,
  compnm,
}) => {
  const url = `${server.apiURL}genio/ticket`;
  const data = {
    vertical,
    category,
    ticket_creator: ticketCreator,
    nm,
    created_by: createdBy,
    mob,
    issue_type: issueType,
    issue_sub_type: issueSubType,
    issue_comment: issueComment,
    document: document.length > 0 ? document : [],
    city,
    oid,
    orderid: orderId,
    docid,
    src,
    src_typ: srcType,
    src_nm: srcNm,
    src_mob: srcMob,
    projectId,
    parentId,
    compnm,
  };
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(data),
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  const responseData = response;
  return responseData;
};

export const PostIssueSubmit = async (issueParams) => {
  const url = `${server.apiURL}genio/issue`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(issueParams),
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  return response;
};

export const decodeToken = async (token) => {
  const url = `${server.apiURL}genio/decodeToken`;
  const options = {
    method: 'POST',
    headers: {
      Authorization: token,
      credentials: 'include',
    },
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  return response;
};

export const getAdvSearchBusinessData = async (paramsBody) => {
  try {
    if (!paramsBody.city) {
      throw new Error('Invalid Params!');
    }

    const url = `${server.apiURL}genio/getAdvSearchBusiness`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paramsBody),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (data.errorCode !== 0) {
      throw new Error(data.message || 'Error getAdvSearchBusinessData');
    }
    return data;
  } catch (e) {
    throw new Error(e.message || 'Error getAdvSearchBusinessData');
  }
};

export const getCompanyData = async (docId) => {
  try {
    if (!docId) {
      throw new Error('Invalid Params!');
    }
    const url = `${server.apiURL}genio/getCompanyDetails?docId=${docId}`;
    const result = await fetch(url, {
      credentials: 'include',
    });
    return result.json();
  } catch (e) {
    throw new Error(e.message || 'Error fetching getCompanyData');
  }
};

export const sendCommunicationCS = async (params) => {
  try {
    const url = `${server.apiURL}comm/sendCommunicationCS`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    return data;
  } catch (e) {
    console.log(e.message);
    throw new Error(e.message || 'Error sendCommunicationCS');
  }
};

export const genEditListingToken = async (params) => {
  try {
    if (!params.docId || !params.eid || !params.city || !params.empName) {
      throw new Error('Invalid Params!');
    }

    const body = {
      docId: params.docId,
      eid: params.eid,
      city: params.city,
      backurl: params.backUrl || '',
      empName: params.empName || '',
      mobile: params.mobile || '',
    };

    const url = `${server.apiURL}listing/generateToken`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'include',
    };
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (data.errorCode !== 0) {
      throw new Error(data.message || 'Error generating Token');
    }
    return { token: data.result.token || '', closedDown: data.result.closedDown || 0 };
  } catch (e) {
    throw new Error(e.message || 'Error generating Token');
  }
};
